import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import Text from "components/Text";
import "./ChatModal.scss";
import Loader from "components/Loader";
import { addDefaultStaffRounded } from "utils";
import InfiniteScroll from "react-infinite-scroll-component";
import NewConversationToast from "Messenger/pages/PatientConversation/component/NewConversationToast";
import PerformanceReviewSearchBar from "accountOwner/pages/PerformanceReview/components/PerformanceReviewSearchBar";
import OutsideClickHandler from "react-outside-click-handler";
import { LoaderIcon } from "react-hot-toast";
import userDefaultImage from "assets/images/staff-default-rounded.png";

function NewGroupPopup(props) {
  const {
    t,
    stateData,
    isNewConversationOfficePopupOpen,
    setIsNewConversationOfficePopupOpen,
    selectedOfficesLabel,
    selectedRolesLabel,
  } = props;
  const { state, otherMethods } = stateData;
  const {
    staffMembers,
    selectedStaff,
    searchText,
    isLoadingStaffList,
    actionInProgress,
    hasMoreStaff,
    hasMoreOffices,
    offices,
    selectedOffices,
    selectedDesignations,
    designations,
  } = state;

  const {
    isThisUserSelected,
    handleSelectStaff,
    closeStepOneModal,
    handleStepOne,
    disableOtherUsers,
    loadMoreStaff,
    loadMoreOffices,
    searchStaffHandler,
    handleOfficeFilterForStaff,
    handleDesignationFilterForStaff,
    resetStaffListFilterStates,
  } = otherMethods;
  const [isRoleFilterPopupOpen, setIsRoleFilterPopupOpen] = useState(false);

  useEffect(() => {
    return () => {
      resetStaffListFilterStates();
    };
  }, []);

  return (
    <Modal
      isOpen={true}
      toggle={closeStepOneModal}
      className="modal-dialog-centered modal-width-660 new-grop-modal"
      modalClassName="custom-modal"
    >
      {(isLoadingStaffList || actionInProgress) && <Loader />}
      <span className="close-btn" onClick={closeStepOneModal}>
        <img src={require("assets/images/cross.svg").default} alt="close" />
      </span>
      <ModalBody>
        <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
          {t("messenger.newTeamChat")}
        </Text>
        <NewConversationToast text={t("messenger.groupNote")} />
        <div className="new-group-searchbar-dropdown-wrapper">
          <div className="new-group-search-row">
            <PerformanceReviewSearchBar
              searchValue={searchText}
              handleSearchTerm={(ev) => searchStaffHandler(ev.target.value)}
              placeholderText="Search by name"
              isFromPatientConversation={true}
            />
          </div>
          <div className="new-group-filter-row">
            <OutsideClickHandler
              onOutsideClick={() => setIsNewConversationOfficePopupOpen(false)}
            >
              <Dropdown
                isOpen={isNewConversationOfficePopupOpen}
                toggle={() => {}}
                className="cursor-pointer new-group-filter-dropdown"
              >
                <DropdownToggle
                  caret={false}
                  onClick={() =>
                    setIsNewConversationOfficePopupOpen(
                      !isNewConversationOfficePopupOpen,
                    )
                  }
                  className="dropdown-btn dropdown-new"
                  tag="div"
                >
                  <span className="dropdown-name-toggle">
                    {selectedOfficesLabel(selectedOffices)}
                    {selectedOffices?.some((option) => option.value !== 0) && (
                      <span className="notification-dot-new">•</span>
                    )}
                  </span>

                  <img
                    src={require("assets/images/chat-down-arrow.svg").default}
                    className="caret-img"
                    alt="caret"
                  />
                </DropdownToggle>
                <DropdownMenu end id="offices-list" className="menu-new">
                  <InfiniteScroll
                    dataLength={offices?.length}
                    hasMore={hasMoreOffices}
                    next={loadMoreOffices}
                    scrollableTarget="offices-list"
                    loader={
                      <DropdownItem tag="div">
                        <LoaderIcon style={{ margin: "0 auto" }} />
                      </DropdownItem>
                    }
                    scrollThreshold={0.5}
                  >
                    {offices.map((of) => (
                      <DropdownItem key={of.value} tag="div" title={of.label}>
                        <div className="ch-checkbox">
                          <label className="mb-0">
                            <input
                              value={of.value}
                              name={of.name}
                              checked={
                                selectedOffices?.length
                                  ? selectedOffices?.some(
                                      (item) => item.value === of.value,
                                    )
                                  : !of.value
                              }
                              onChange={() => handleOfficeFilterForStaff(of)}
                              type="checkbox"
                            />
                            <span> {of.label} </span>
                          </label>
                        </div>
                      </DropdownItem>
                    ))}
                  </InfiniteScroll>
                </DropdownMenu>
              </Dropdown>
            </OutsideClickHandler>

            <OutsideClickHandler
              onOutsideClick={() => setIsRoleFilterPopupOpen(false)}
            >
              <Dropdown
                isOpen={isRoleFilterPopupOpen}
                toggle={() => {}}
                className="cursor-pointer new-group-filter-dropdown"
              >
                <DropdownToggle
                  caret={false}
                  onClick={() =>
                    setIsRoleFilterPopupOpen(!isRoleFilterPopupOpen)
                  }
                  className="dropdown-btn dropdown-new"
                  tag="div"
                >
                  <span className="dropdown-name-toggle">
                    {selectedRolesLabel(selectedDesignations)}
                    {selectedDesignations?.some(
                      (option) => option.value !== 0,
                    ) && <span className="notification-dot-new">•</span>}
                  </span>

                  <img
                    src={require("assets/images/chat-down-arrow.svg").default}
                    className="caret-img"
                    alt="caret"
                  />
                </DropdownToggle>
                <DropdownMenu end id="roles-list" className="menu-new">
                  {designations.map((role) => (
                    <DropdownItem key={role.value} tag="div" title={role.label}>
                      <div className="ch-checkbox">
                        <label className="mb-0">
                          <input
                            value={role.value}
                            checked={
                              selectedDesignations?.length
                                ? selectedDesignations?.some(
                                    (item) => item.value === role.value,
                                  )
                                : !role.value
                            }
                            onChange={() =>
                              handleDesignationFilterForStaff(role)
                            }
                            type="checkbox"
                          />
                          <span> {role.label} </span>
                        </label>
                      </div>
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </OutsideClickHandler>
          </div>
        </div>
        {!!selectedStaff?.length && (
          <Text
            size="12px"
            marginBottom="10px"
            weight="400"
            color="rgb(111, 119, 136)"
          >
            {selectedStaff.length} {t("Selected")}
          </Text>
        )}

        {staffMembers?.length > 0 && (
          <InfiniteScroll
            dataLength={staffMembers?.length}
            hasMore={hasMoreStaff}
            next={loadMoreStaff}
            scrollableTarget="scrollableDiv"
          >
            <ul className={"modal-employee-list group-list"} id="scrollableDiv">
              {staffMembers
                .filter((staff) =>
                  searchText
                    ? staff.name
                        .toLowerCase()
                        .includes(searchText.toLowerCase())
                    : true,
                )
                .map((staff) => {
                  return (
                    <li key={staff.id}>
                      <div
                        className={`ch-checkbox ${
                          disableOtherUsers(staff) ? "disable-btns" : ""
                        }`}
                      >
                        <label>
                          <input
                            type="checkbox"
                            checked={isThisUserSelected(staff)}
                            onChange={(e) => handleSelectStaff(e, staff)}
                            disabled={disableOtherUsers(staff)}
                          />
                          <span>
                            <img
                              src={staff.profilePic || userDefaultImage}
                              alt="profile-pic"
                              onError={addDefaultStaffRounded}
                            />
                            <div> {staff.name}</div>
                          </span>
                        </label>
                      </div>
                    </li>
                  );
                })}
            </ul>
          </InfiniteScroll>
        )}
        {!staffMembers?.length && (
          <div className="empty-channel-list text-center mx-auto py-5">
            <img
              src={require("assets/images/empty-icon.svg").default}
              alt="no-staff"
            />
            <h3> {t("noStaffMemberFound")}</h3>
          </div>
        )}
        <div className="d-sm-flex btn-box">
          <button
            type="button"
            disabled={!staffMembers?.length}
            onClick={() => handleStepOne()}
            className={
              "button button-round button-shadow  w-sm-100  mr-sm-3 mb-2"
            }
          >
            {selectedStaff?.length < 2
              ? t("messenger.startChat")
              : t("messenger.startGroup")}
          </button>

          <button
            type="button"
            onClick={() => closeStepOneModal()}
            className="button mb-md-2 btn-mobile-link button-round button-border button-dark"
          >
            {t("cancel")}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(NewGroupPopup);
